module.exports = __webpack_public_path__ + "img/right1_active.4d39f519.svg";